import { GlDisclosureDropdown, GlForm, GlFormTextarea, GlButton, GlAlert } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { __, n__ } from '~/locale';
export default {
    name: 'ApplySuggestion',
    components: {
        GlDisclosureDropdown,
        GlForm,
        GlFormTextarea,
        GlButton,
        GlAlert
    },
    props: {
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        defaultCommitMessage: {
            type: String,
            required: false,
            default: null
        },
        batchSuggestionsCount: {
            type: Number,
            required: false,
            default: 0
        },
        errorMessage: {
            type: String,
            required: false,
            default: null
        }
    },
    emits: [
        'apply'
    ],
    data () {
        return {
            message: null
        };
    },
    computed: {
        dropdownText () {
            if (this.batchSuggestionsCount <= 1) {
                return __('Apply suggestion');
            }
            return n__('Apply %d suggestion', 'Apply %d suggestions', this.batchSuggestionsCount);
        },
        helperText () {
            if (this.batchSuggestionsCount <= 1) {
                return __('This also resolves this thread');
            }
            return __('This also resolves all related threads');
        }
    },
    methods: {
        onApply () {
            this.$emit('apply', this.message);
        },
        focusCommitMessageInput () {
            this.$refs.commitMessage.$el.focus();
        }
    }
};
